"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const formik_1 = require("formik");
const ri_1 = require("react-icons/ri");
const RenderSelectField = (props) => {
    const { field: { value, name, onChange, onBlur }, form: { touched, errors, setFieldTouched, submitCount, values, setFieldValue }, label, placeholder, options, onValueChange = () => undefined, parentField, ...otherProps } = props;
    const error = (0, formik_1.getIn)(errors, name);
    const touch = (0, formik_1.getIn)(touched, name);
    const parentFieldRef = (0, react_1.useRef)(null);
    const displayErrors = (touch || submitCount > 0) && !!error;
    const handleChange = (event) => {
        onChange(event);
        onValueChange(event.target.value);
    };
    if (parentField) {
        (0, react_1.useEffect)(() => {
            if (parentFieldRef.current && parentFieldRef.current !== values[parentField]) {
                setFieldValue(name, undefined);
            }
            parentFieldRef.current = values[parentField];
        }, [values[parentField]]);
    }
    return (react_1.default.createElement("div", null,
        label && (react_1.default.createElement("div", { className: "mb-1.5" },
            react_1.default.createElement(core_1.InputLabel, null, label))),
        react_1.default.createElement(core_1.Select, { name: name, fullWidth: true, className: "text-text", inputProps: {
                displayEmpty: true,
                onClose: () => setFieldTouched(name, true),
            }, IconComponent: () => (react_1.default.createElement(ri_1.RiArrowDownSLine, { size: "1.5em", className: "pointer-events-none absolute right-2 text-text" })), disableUnderline: true, error: touch && !!error, value: value || '', onChange: handleChange, onBlur: onBlur, ...otherProps },
            options.map((option, key) => (react_1.default.createElement(core_1.MenuItem, { key: key, value: option.value }, option.label))),
            !options.length && react_1.default.createElement(core_1.MenuItem, null, "No options")),
        displayErrors && (react_1.default.createElement(core_1.Typography, { variant: "body2", component: "p", color: "error", ...otherProps }, error))));
};
RenderSelectField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    options: prop_types_1.default.array.isRequired,
    onValueChange: prop_types_1.default.func,
    parentField: prop_types_1.default.string,
};
exports.default = RenderSelectField;
